import { message, Modal } from 'antd';
import React, { useState } from 'react';
import { useBatchSetDomainMutation } from '../../../../../../../graphql/mutations.generated';
import { SetDomainModal } from '../../../../containers/profile/sidebar/Domain/SetDomainModal';
import { useTranslation } from '../../../../../../../i18n/useTranslation';
import { handleBatchError } from '../../../../utils';
import ActionDropdown from './ActionDropdown';

type Props = {
    urns: Array<string>;
    disabled: boolean;
    refetch?: () => void;
    tooltip?: string;
};

// eslint-disable-next-line
export default function DomainsDropdown({ urns, disabled = false, refetch, tooltip }: Props) {
    const { t } = useTranslation();
    const [isEditModalVisible, setIsEditModalVisible] = useState(false);
    const [batchSetDomainMutation] = useBatchSetDomainMutation();

    const batchUnsetDomains = () => {
        batchSetDomainMutation({
            variables: {
                input: {
                    resources: [...urns.map((urn) => ({ resourceUrn: urn }))],
                },
            },
        })
            .then(({ errors }) => {
                if (!errors) {
                    message.success({ content: t('Removed Domain!'), duration: 2 });
                    refetch?.();
                }
            })
            .catch((e) => {
                message.destroy();
                message.error(
                    handleBatchError(urns, e, {
                        content: `Failed to remove assets from Domain: \n ${e.message || ''}`,
                        duration: 3,
                    }),
                );
            });
    };

    return (
        <>
            <ActionDropdown
                name="Domain"
                actions={[
                    {
                        title: t('Set Domain'),
                        onClick: () => {
                            setIsEditModalVisible(true);
                        },
                    },
                    {
                        title: t('Unset Domain'),
                        onClick: () => {
                            Modal.confirm({
                                title: t('If you continue, Domain will be removed for the selected assets.'),
                                content: t('Are you sure you want to unset Domain for these assets?'),
                                onOk() {
                                    batchUnsetDomains();
                                },
                                onCancel() {},
                                okText: t('Yes'),
                                cancelText: t('Cancel'),
                                maskClosable: true,
                                closable: true,
                                centered: true,
                            });
                        },
                    },
                ]}
                disabled={disabled}
                tooltip={tooltip}
            />
            {isEditModalVisible && (
                <SetDomainModal
                    urns={urns}
                    onCloseModal={() => {
                        setIsEditModalVisible(false);
                        refetch?.();
                    }}
                />
            )}
        </>
    );
}
